import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRoutes from "./router/AppRoutes.js";
import {Greet} from "./shared/Greet.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Greet>
      <AppRoutes />
    </Greet>
  </>
);
